// Native
import { useState } from "react"

// Components
import { AlertDialogBody, AlertDialogFooter, Button, ButtonGroup, Stack, useToast } from "@chakra-ui/react"
import { Dialog, Icon, Label } from "components"

// Config
import { API, Moment } from "config"

export default function Trash({ data, onSuccess = () => {}, ...props }){
    
    const toast = useToast()
    const [ loading, setLoading ] = useState(false)

    const handleTrash = async () => {
        setLoading(true)

        try{
            await API.delete(`/attachments/${data.id}`)
            toast({ title: `O arquivo ${data.filename} foi removido.`, status: 'info' })
            props.onClose()
            onSuccess()
        }catch(err){
            toast({ title: 'Não foi possível excluir o arquivo. Tente novamente', description: err?.response?.data?.message })
        }

        setLoading(false)
    }
    return(
    <Dialog title={`Certeza que deseja excluir o arquivo ${data?.filename}?`} loading={loading} {...props}>
        <AlertDialogBody>
            Ao excluir o arquivo, ele não poderá mais ser restaurado. Tem certeza que deseja continuar?

            <Stack mt={6}>
                <Label label="Nome do arquivo:" children={data?.filename} />
                <Label label="Rótulo/descrição:" children={data?.label} />
                <Label label="Tamanho:" children={data?.size} />
                <Label label="Enviado em:" children={Moment(data?.created_at).format('LLL')} />
            </Stack>
        </AlertDialogBody>
        <AlertDialogFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button children="Excluir arquivo" onClick={handleTrash} isLoading={loading} leftIcon={<Icon name="trash" />} />
                <Button children="Cancelar" onClick={props.onClose} colorScheme="red" />
            </ButtonGroup>
        </AlertDialogFooter>
    </Dialog>   
    )
}